import RequestManager from "src/requests/RequestManager";
import { Match } from "../interfaces";
import { BracketsTask } from "../tasks";
import { parseMatch } from "../utils";
import getAllMatches from "./getAllMatches";
import getPhases from "./getPhases";

type MatchesByRound = {
    roundName: string,
    roundId: string,
    matches: Match[]
}[]

// Se usa en NodoMundial/Partidos
export default async function getMatchesByRound(): Promise<MatchesByRound> {
    const task = new BracketsTask();
    const result = await RequestManager.addRequest(task);
    const rounds = (result.brackets && result.brackets[0] && result.brackets[0].rounds) || [];
    const tercerPuesto = "GN0RDNSRNFX8CN5";

    return rounds
        .filter((round: any) => round.phase && round.phase.id !== tercerPuesto)
        .map((round: any) => ({
            roundName: round.phase && round.phase.names && round.phase.names.default,
            roundId: round.phase && round.phase.id,
            matches: round.pairs && round.pairs.map((pair: any) => parseMatch(pair.matches[0]))
        }))
}


// WEBPACK FOOTER //
// ./src/mundial/requests/api/getMatchesByRound.ts